import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/svg/x.svg?url";
const SvgX = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-x",
  ...props
}, /* @__PURE__ */ React.createElement("line", {
  x1: 18,
  y1: 6,
  x2: 6,
  y2: 18
}), /* @__PURE__ */ React.createElement("line", {
  x1: 6,
  y1: 6,
  x2: 18,
  y2: 18
}));
export {SvgX as ReactComponent};
export default svgUrl;
